module.exports = __webpack_public_path__ + "static/media/021-night.85cc0259.svg";